const U=v=>String(v||'MISSING').toUpperCase();

export function deriveResearchState(bundle={}){
  const market=U(bundle?.market?.status);
  const identity=(U(bundle?.companyFacts?.status)==='VERIFIED'||U(bundle?.alphaCompany?.status)==='VERIFIED')?'VERIFIED':'MISSING';
  const financials=U(bundle?.secFinancials?.status);
  const coverage=bundle?.coverage||{};
  const available=Number.isFinite(Number(coverage?.availableCount))?Number(coverage.availableCount):0;

  const core={
    market,
    identity,
    financials
  };

  let state='REVIEW';
  if(market==='VERIFIED'&&identity==='VERIFIED'&&financials==='VERIFIED')state='LIVE';
  else if(
    market==='VERIFIED'||
    identity==='VERIFIED'||
    ['VERIFIED','PARTIAL'].includes(financials)||
    available>0
  )state='PARTIAL';

  return{
    state,
    core,
    availableEvidence:available,
    note:'Research State is derived only from current modern evidence. Legacy company_snapshot status cannot upgrade or downgrade it, and Research State is not an investment score.'
  };
}
